import { FC } from 'react';
import { CgTime } from 'react-icons/cg';
import { Text } from '@chakra-ui/react';

import { WorkflowStepFormFieldInput } from '../types/workflowStepComponentTypes';
import { FieldToBlock, FieldValueProps } from './declarations';
import { commonFieldBlockProps } from './FieldUtils';

export const TimeFieldToBlock: FieldToBlock<
  'time',
  WorkflowStepFormFieldInput
> = (field) => ({
  ...commonFieldBlockProps(field),
  componentType: 'input',
  componentProps: {
    type: 'time',
    startElement: <CgTime />,
    size: 'sm',
  },
});

type TimeFieldValueProps = FieldValueProps<'time'>;

export const TimeFieldValue: FC<TimeFieldValueProps> = ({ field }) => (
  <Text>{field.value}</Text>
);
